import { render, staticRenderFns } from "./SignupModal.vue?vue&type=template&id=590bf07c&scoped=true&"
import script from "./SignupModal.vue?vue&type=script&lang=js&"
export * from "./SignupModal.vue?vue&type=script&lang=js&"
import style0 from "./SignupModal.vue?vue&type=style&index=0&id=590bf07c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590bf07c",
  null
  
)

export default component.exports